import {
  GET_DASHBOARD_EVENTS_LOADING,
  GET_DASHBOARD_EVENTS_SUCCESS,
  GET_DASHBOARD_EVENTS_ERROR,
} from "../../../constant/actionTypes";

const dashboardCalenderReducer = (
  state = {
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case GET_DASHBOARD_EVENTS_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_DASHBOARD_EVENTS_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case GET_DASHBOARD_EVENTS_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};
export default dashboardCalenderReducer;
